var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", [
    _c(
      "div",
      { staticClass: "search" },
      [
        _c(
          "el-form",
          {
            ref: "routeQueryForm",
            attrs: { model: _vm.query, inline: true, size: "mini" },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "订单号" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入订单号", clearable: "" },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.querySearch.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.query.orderNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "orderNo", $$v)
                    },
                    expression: "query.orderNo",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "日期" } },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                    "end-placeholder": "结束日期",
                  },
                  model: {
                    value: _vm.dateArray,
                    callback: function ($$v) {
                      _vm.dateArray = $$v
                    },
                    expression: "dateArray",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "站点", prop: "stationId" } },
              [
                _c("yd-common-selector", {
                  attrs: {
                    placeholder: "请输入关键字查找线路名称",
                    options: _vm.stationNameList,
                  },
                  model: {
                    value: _vm.query.stationId,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "stationId", $$v)
                    },
                    expression: "query.stationId",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "司机车牌", prop: "driverInfo" } },
              [
                _c("el-input", {
                  attrs: { clearable: "", placeholder: "请输入内容" },
                  model: {
                    value: _vm.query.driverInfo,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "driverInfo", $$v)
                    },
                    expression: "query.driverInfo",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-search",
                      loading: _vm.loading,
                    },
                    on: { click: _vm.searchChange },
                  },
                  [_vm._v("\n          筛选\n        ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "danger",
                      icon: "el-icon-delete",
                      loading: _vm.loading,
                    },
                    on: { click: _vm.searchReset },
                  },
                  [_vm._v("\n          清空\n        ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: { click: _vm.openMap },
                  },
                  [_vm._v("查看在线司机")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "yd-table",
          {
            attrs: {
              data: _vm.driverData,
              loading: _vm.loading,
              pagination: _vm.pagination,
            },
            on: { onChange: _vm.onTableChange },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: "司机",
                prop: "driverName",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.driverName || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "已接订单编号",
                prop: "orderNo",
                align: "center",
                width: "300",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            placement: "right",
                            effect: "dark",
                            trigger: "hover",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyOrderNo(
                                              scope.row.orderNo
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("复制")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("el-button", { attrs: { type: "text" } }, [
                            _vm._v(_vm._s(scope.row.orderNo)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "车辆牌照",
                prop: "carNum",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            placement: "right",
                            effect: "dark",
                            trigger: "hover",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyOrderNo(
                                              scope.row.carNum
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("复制")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("el-button", { attrs: { type: "text" } }, [
                            _vm._v(_vm._s(scope.row.carNum)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单类型",
                prop: "type",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.type ? scope.row.type : "接单") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单距离（公里）",
                prop: "orderDistance",
                align: "center",
                width: "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.orderDistance || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "实际付给司机金额",
                prop: "price",
                align: "center",
                width: "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.price / 100 || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "接单时间",
                prop: "robTime",
                align: "center",
                width: "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.robTime || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单出发时间",
                prop: "tripTime",
                align: "center",
                width: "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.tripTime || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "接单时经度",
                prop: "robPoint",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            scope.row.robPoint
                              ? scope.row.robPoint.lon.toFixed(6)
                              : "-"
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "接单时纬度",
                prop: "driverPhone",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            scope.row.robPoint
                              ? scope.row.robPoint.lat.toFixed(6)
                              : "-"
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "接单时离出发地距离（公里）",
                prop: "robDistance",
                align: "center",
                width: "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            parseInt(scope.row.robDistance / 1000) || "-"
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "是否拼单",
                prop: "mergeType",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.mergeType === 1 ? "是" : "否") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.visible
      ? _c(
          "div",
          [
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "司机位置信息",
                  visible: _vm.visible,
                  width: "1200px",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.visible = $event
                  },
                },
              },
              [
                _c("MapInfo", {
                  attrs: { data: _vm.mapData, centerPoint: _vm.centerPoint },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }